import api from './utilPartner';

const controller = 'Cargo';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarCargos: function () {
    return api.Axios.GetParams(url);
  }
});
